import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core'
import { CompanyInputModule } from '@shared/components/company-input/company-input.module';
import { FileUploadModule } from '@shared/components/file-upload/file-upload.module';
import { InputModule } from '@shared/components/input/input.module';
import { CreateTicketDialogComponent } from './create-ticket-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    declarations: [CreateTicketDialogComponent],
    imports: [
        CommonModule,
        InputModule,
        FileUploadModule,
        CompanyInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule
    ],
    exports: [
        CreateTicketDialogComponent,
    ]
})
export class CreateTicketDialogModule {}